import ProductSingle from './ProductSingle/ProductSingle'

/* Don't touche under this line for security reasons */
document.addEventListener("DOMContentLoaded", function() {

    ProductSingle.init()

})
